import React from "react";
import styled from "styled-components";
import DownloadApp from "./DownloadApp";
import Features from "./Features";
import Hero from "./Hero";
import Navbar from "./Navbar";
import Service from "./Service";
import Footer from "./Footer";

function Home() {
  return (
    <Container>
      <Navbar />
      <Hero />
      <Service />
      <Features
        tagline="WHY CHOOSE US"
        headline="Find Favorites and Discover New Ones"
        description="At vero eos et accusamus et iusto odio dignissimos ducimus blanditiis praesen voluptatum deleniti."
        image="./image1.png"
        button="Explore Now"
        reverse={true}
      />
      <Features
        tagline="HOME DELIVERY"
        headline="Sit at Home We Will Take Care Your Order"
        description="At vero eos et accusamus et iusto odio dignissimos ducimus blanditiis praesen voluptatum deleniti."
        image="./image2.png"
        button="Explore Now"
        reverse={false}
      />

      <DownloadApp />
      <Footer />
    </Container>
  );
}

const Container = styled.div`
  width: 100vw;
  height: 100vh;
  margin: auto;
  max-width: 1824px;
`;

export default Home;
